export default __webpack_public_path__ + "static/media/sparck-appreciation-card-header-4.4361d608.png";